import LearningSearchContentPage from "lx/learningSearchContentPage";

export { LearningSearchContentPage };

customElements.define(
  "lx-learning-search-content-page",
  LearningSearchContentPage.CustomElementConstructor
);
